import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'
import './pixelRuntime'

const GTAG_JS_URL = 'https://www.googletagmanager.com/gtag/js'

const buildGtagConfigSnippet = (
    ga4Id: string | null | undefined,
    googleAdsId: string | null | undefined,
): string => {
    const configLines: string[] = []

    if (ga4Id) {
        configLines.push(`gtag('config', '${ga4Id}');`)
    }
    if (googleAdsId) {
        configLines.push(
            `gtag('config', '${googleAdsId}', { send_page_view: false });`,
        )
    }

    return `
        window.dataLayer = window.dataLayer || [];
        if (typeof gtag === 'undefined') {
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        }
        ${configLines.join('\n')}
        window.__sfMarkVendorReady && window.__sfMarkVendorReady('googleGtag');
    `
}

// Ready signal comes from inside the inline snippet (via __sfMarkVendorReady,
// installed by pixelRuntime), not from <Script onReady>. Next.js fires onReady
// before an inline body executes, which would drain the queue while
// window.gtag is still undefined.
export const GtagPixel: React.FC<{ landingPage: ApiShopperLandingPage }> = ({
    landingPage,
}) => {
    const ga4Id = landingPage.integrations.ga4PixelId
    const googleAdsId = landingPage.integrations.googleAdsTagId

    if (!ga4Id && !googleAdsId) return null

    const primaryId = ga4Id || googleAdsId

    return (
        <>
            <Script
                id="gtag-external-src"
                async
                src={`${GTAG_JS_URL}?id=${primaryId}`}
                strategy="afterInteractive"
            />
            <Script
                id="google-gtag-inline"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: buildGtagConfigSnippet(ga4Id, googleAdsId),
                }}
            />
        </>
    )
}
